import { Share2, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/use-toast";

interface HeaderProps {
  onClearChat: () => void;
  onShare: () => void;
}

export const Header = ({ onClearChat, onShare }: HeaderProps) => {
  return (
    <header className="sticky top-0 z-10 bg-background/80 backdrop-blur-sm border-b border-border/40">
      <div className="max-w-3xl mx-auto px-4 py-2 flex items-center justify-between">
        <img 
          src="/lovable-uploads/9f519a7a-3214-4ea8-b161-323bb2cbc183.png" 
          alt="CarQuest.ai Logo" 
          className="h-8 w-auto"
        />
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="sm"
            className="gap-1.5 text-muted-foreground hover:text-foreground"
            onClick={onShare}
          >
            <Share2 className="h-3.5 w-3.5" />
            Share
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="gap-1.5 text-muted-foreground hover:text-destructive"
            onClick={onClearChat}
          >
            <Trash2 className="h-3.5 w-3.5" />
            Clear
          </Button>
        </div>
      </div>
    </header>
  );
};